<template>
	<bw-table
			aria-label="data-table"
			:headers="headers"
			:items="products"
			showDateFilter="created_at"
	>
		<template v-slot:item.created_at="{ item: product }">
			{{ new Date(product.created_at).toLocaleString() }}
		</template>
		<template v-slot:item.actions="{ item: product }">
			<div class="d-flex">
				<v-btn
						color="secondary"
						depressed
						fab
						:href="viewProduct(product)"
						small
				>
					<v-icon small>mdi-package-variant-closed</v-icon>
				</v-btn>
				<!--				<v-btn-->
				<!--						class="px-0"-->
				<!--						color="accent"-->
				<!--						depressed-->
				<!--						:href="editProduct(product)"-->
				<!--						small-->
				<!--				>-->
				<!--					<v-icon small>mdi-pencil-outline</v-icon>-->
				<!--				</v-btn>-->
			</div>
		</template>
	</bw-table>
</template>

<script>
export default {
	name: 'Products',
	props: {
		productsData: {
			type: Array,
			default: () => []
		},
		venue: {
			type: Object | null,
			default: null
		},
		partner: {
			type: Object | null,
			default: null
		}
	},
	data() {
		return {
			headers: [
				{
					align: 'start',
					mandatory: true,
					text: 'Name',
					value: 'name'
				},
				{
					align: 'start',
					filterOn: 'statusName',
					selected: true,
					text: 'Status',
					value: 'statusName',
					width: 'auto'
				},
				{
					align: 'start',
					selected: true,
					sortable: false,
					text: 'Created',
					value: 'created_at',
					width: 'auto'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%'
				}
			],
			products: this.productsData
		};
	},
	computed: {
		baseUrl() {
			return this.partner
					? `/partner-portal/${this.partner.id}`
					: `/merchant-portal/${this.venue.id}`;
		}
	},
	created() {
	},
	methods: {
		editProduct(product) {
			return this.baseUrl + `/products/main/edit-product/${product.id}`
		},
		viewProduct(product) {
			return this.baseUrl + `/products/main/view-product/${product.id}`
		}
	}
};
</script>

<style lang="scss" scoped></style>
